import { useState, useEffect, useRef } from 'react';
import categories from '../../../demo/categories.json';
import './CategoriesDropdown.scss';
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Category } from '../../../types/Category';
import { executeFetch } from '../../../helper/Api';
import useCategoryStore from '../../../store/categoryStore';
const CategoriesDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState<Category | null>(null);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const handleCategoryClick = (category) => {
    setSelectedCategory(selectedCategory?.id === category.id ? null : category);
  };
  const {categories} = useCategoryStore();

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
      setSelectedCategory(null);
    }
  };
  const handleClickSubCat = (subcategory) => {
    setIsOpen(false);
    navigate(`/products?c=${subcategory.id}`);
  }

  //Effects
  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
 const handleProductsClick = () => {
        navigate("/products");
    };
  
   return (
        <div className="categories-dropdown">
            <div
                className="products-text"
                onClick={handleProductsClick}
            >
                Προϊόντα
            </div>
        </div>
    );
  // return (
  //   <div className="categories-dropdown" ref={dropdownRef}>
  //     <div className="products-text" onClick={() => setIsOpen(!isOpen)}>
  //       Προϊόντα
  //     </div>
  //     {isOpen && (
  //       <div className="categories-list">
  //         {categories.map((category) => (
  //           <div
  //             key={category.id}
  //             className="category-item"
  //             onClick={() => handleCategoryClick(category)}
  //           >
  //             {category.name}
  //             {selectedCategory?.id === category.id && (
  //               <div className="subcategories-list">
  //                 {category.children.map((subcategory) => (
  //                   <div key={subcategory.id} className="subcategory-item"   onClick={() => handleClickSubCat(subcategory)}>
  //                     {subcategory.name}
  //                   </div>
  //                 ))}
  //               </div>
  //             )}
  //           </div>
  //         ))}
  //       </div>
  //     )}
  //   </div>
  // );
};

export default CategoriesDropdown;
